// Routes du module « documentation » (chemins relatifs à la coque).
import type { RouteObject } from 'react-router';
import '../../styles/documentation.css';
import { PageBibliotheque } from './PageBibliotheque.tsx';
import { PageImporter } from './PageImporter.tsx';
import { PageCouverture } from './PageCouverture.tsx';
import { PageTraitements } from './PageTraitements.tsx';
import { PageDocument } from './PageDocument.tsx';
import { PageLecteur } from './PageLecteur.tsx';

export const routesDocumentation: RouteObject[] = [
  { path: 'documentation', element: <PageBibliotheque /> },
  { path: 'documentation/importer', element: <PageImporter /> },
  { path: 'documentation/couverture', element: <PageCouverture /> },
  { path: 'documentation/traitements', element: <PageTraitements /> },
  { path: 'documentation/lecteur/:versionId', element: <PageLecteur /> },
  { path: 'documentation/:id', element: <PageDocument /> },
];
